<template>
    <div class="resumeOther">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>证书</h1>
            </el-col>
            <el-col :span="20">
                <div class="resumeContent" v-for="(item,index) in resumeInfo.certList">
                    <el-row>
                        <el-col :span="12">
                            <p><b>{{item.getTime}}</b></p>
                        </el-col>
                        <el-col :span="12">
                            <p>
                                <el-tooltip popper-class="certImgTip" effect="light" placement="bottom">
                                    <b>{{item.name}}</b>
                                    <template #content v-if="item.attachment">
                                        <div class="certImg" v-if="item.attachment">
                                            <img :src="location(item.attachment)"/>
                                        </div>
                                    </template>
                                </el-tooltip>
                            </p>
                        </el-col>
                    </el-row>                    
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    export default {
        name: 'cert',
        props: ['resumeInfo'],
        data () {
            return {
            };
        },
        computed: {
            location(){
                return function (attachment){
                    let imagePath = encodeURI(attachment);
                    return `/files?imagePath=${imagePath}`;
                }
            },
            // 简历工作经历列表数量
            certSize(){
                return this.size();
            }
        },
        methods: {
            // 计算简历工作经历数量
            size(){
                var certSize = 0;
                for(var i in this.resumeInfo.certList) {
                    certSize++;
                }
                return certSize;
            },
        }
    }
</script>